import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Faculty from './pages/Faculty';
import TutorDetail from './pages/TutorDetail';
import Batches from './pages/Batches'; // New
import BatchDetail from './pages/BatchDetail';
import StudentDetail from './pages/StudentDetail';
import Enquiries from './pages/Enquiries';
import Library from './pages/Library';
import StudentHub from './pages/StudentHub'; // New
import Parents from './pages/Parents'; // New
import FinancialAuditor from './pages/FinancialAuditor'; // New
import AcademyLadder from './pages/AcademyLadder'; // New
import AttendanceCenter from './pages/AttendanceCenter'; // New
import FinancialHub from './pages/FinancialHub'; // New
import LandingManager from './pages/LandingManager';
import Closures from './pages/Closures'; // New
import Merchandise from './pages/Merchandise'; // New
import Approvals from './pages/Approvals'; // New
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import DeleteAccount from './pages/DeleteAccount';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PasswordReset from './pages/PasswordReset';
import UniversalSearch from './pages/UniversalSearch';
import './index.css';

function LoadingScreen() {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#111111', flexDirection:'column', gap:16 }}>
      <div style={{ fontFamily:"'Playfair Display',serif", fontSize:36, fontWeight:700, color:'#fff' }}>
        Academic<span style={{ color:'#c04060' }}>ix</span>
      </div>
      <div style={{ width:48, height:48, border:'3px solid rgba(192,64,96,.15)', borderTop:'3px solid #c04060', borderRadius:'50%', animation:'spin .8s linear infinite' }}></div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return token ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return token ? <Navigate to="/dashboard" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<PrivateRoute><Overview /></PrivateRoute>} />
          <Route path="/faculty" element={<PrivateRoute><Faculty /></PrivateRoute>} />
          <Route path="/faculty/:id" element={<PrivateRoute><TutorDetail /></PrivateRoute>} />
          <Route path="/batches" element={<PrivateRoute><Batches /></PrivateRoute>} />
          <Route path="/batches/:id" element={<PrivateRoute><BatchDetail /></PrivateRoute>} />
          <Route path="/students/:id" element={<PrivateRoute><StudentDetail /></PrivateRoute>} />
          <Route path="/enquiries" element={<PrivateRoute><Enquiries /></PrivateRoute>} />
          <Route path="/library" element={<PrivateRoute><Library /></PrivateRoute>} />
          <Route path="/students" element={<PrivateRoute><StudentHub /></PrivateRoute>} />
          <Route path="/parents" element={<PrivateRoute><Parents /></PrivateRoute>} />
          <Route path="/payments" element={<PrivateRoute><FinancialAuditor /></PrivateRoute>} />
          <Route path="/financial-hub" element={<PrivateRoute><FinancialHub /></PrivateRoute>} />
          <Route path="/attendance" element={<PrivateRoute><AttendanceCenter initialTab="students" /></PrivateRoute>} />
          <Route path="/tutor-attendance" element={<PrivateRoute><AttendanceCenter initialTab="tutors" /></PrivateRoute>} />
          <Route path="/closures" element={<PrivateRoute><Closures /></PrivateRoute>} />
          <Route path="/merchandise" element={<PrivateRoute><Merchandise /></PrivateRoute>} />
          <Route path="/approvals" element={<PrivateRoute><Approvals /></PrivateRoute>} />
          <Route path="/password-reset" element={<PrivateRoute><PasswordReset /></PrivateRoute>} />
          <Route path="/universal-search" element={<PrivateRoute><UniversalSearch /></PrivateRoute>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/landing-manager" element={<PrivateRoute><LandingManager /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><AcademyLadder /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
